<template>
  <div>
 
  <MovimientoAgrupado :id_puesto="store.state.puestoSelect.id_puesto" />
</div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiPoll, mdiLabelVariantOutline, mdiCurrencyUsd, mdiHelpCircleOutline } from '@mdi/js'
import MovimientoAgrupado from '@/views/sistema/inventario/reporte/movimiento-agrupado/MovimientoAgrupado.vue'
import store from '@/store'
// demos

export default {
  components: { MovimientoAgrupado },
  setup() {
    return {store}
  },
}
</script>
